import request from '@/utils/request'


// 查询轮播图列表
export function listBanner(query) {
  return request({
    url: '/banner/banners/list',
    method: 'get',
    params: query
  })
}

// 查询轮播图分页
export function pageBanner(query) {
  return request({
    url: '/banner/banners/page',
    method: 'get',
    params: query
  })
}
export function changeIsOpen(data) {
  return request({
    url: '/banner/banners/changeIsOpen',
    method: 'post',
    params: data
  })
}

// 查询轮播图详细
export function getBanner(data) {
  return request({
    url: '/banner/banners/detail',
    method: 'get',
    params: data
  })
}

// 新增轮播图
export function addBanner(data) {
  return request({
    url: '/banner/banners/add',
    method: 'post',
    data: data
  })
}

// 修改轮播图
export function updateBanner(data) {
  return request({
    url: '/banner/banners/edit',
    method: 'post',
    data: data
  })
}

// 删除轮播图
export function delBanner(data) {
  return request({
    url: '/banner/banners/delete',
    method: 'post',
    data: data
  })
}

// 获取轮播图相关配置（播放秒数、开始播放秒数、展示秒数）
export function getBannerConfigs() {
  return request({
    url: '/system/configs/getBannerConfigs',
    method: 'get'
  })
}

// 批量更新轮播图相关配置
export function updateBannerConfigs(configList) {
  return request({
    url: '/system/configs/updateBannerConfigs',
    method: 'post',
    data: configList
  })
}